import { useState, useEffect } from 'react';
import { adminCustomerService, CustomerQuery, CustomerProfile, CustomerSegments } from '@services/adminCustomerService';

export function useAdminCustomers(query: CustomerQuery) {
  const [customers, setCustomers] = useState<CustomerProfile[]>([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadCustomers = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const result = await adminCustomerService.listCustomers(query);
        if (isMounted) {
          setCustomers(result.customers);
          setTotal(result.total);
        }
      } catch (err: any) {
        if (isMounted) {
          setError(err.response?.data?.error?.message || 'Müşteriler yüklenemedi');
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadCustomers();

    return () => {
      isMounted = false;
    };
  }, [query.page, query.limit, query.search, query.segment, query.sortBy]);

  return { customers, total, isLoading, error };
}

export function useCustomerSegments() {
  const [segments, setSegments] = useState<CustomerSegments | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadSegments = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const result = await adminCustomerService.getCustomerSegments();
        if (isMounted) {
          setSegments(result);
        }
      } catch (err: any) {
        if (isMounted) {
          setError(err.response?.data?.error?.message || 'Segmentler yüklenemedi');
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadSegments();

    return () => {
      isMounted = false;
    };
  }, []);

  return { segments, isLoading, error };
}
